export default __webpack_public_path__ + "static/media/GothaLigIta.d6385d4c.otf";